// WizardStep1.js
import { useEffect } from 'react';
import MembershipSummaryBanner from './MembershipSummaryBanner';
import Utilities from '../../../../../../../../services/commonservice/utilities';

const MembershipPeriodUnitList = [
  { label: 'Month(s)', value: 'Month' },
  { label: 'Quarter(s)', value: 'Quarter' },
  { label: 'Year(s)', value: 'Year' }
];

const WizardStep1a = ({ formData, onChange, enableNext }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    onChange({ [name]: type === 'checkbox' ? checked : value });
  };


  useEffect(() => {
    // const isValid = (formData.name && formData.practiceLocationId && formData.membershipType && formData.unitPrice);
    const isValid = (formData.membershipPeriodQty && formData.membershipPeriodUnit && formData.membershipOfferBeginsOn);
    enableNext(isValid);
  }, [formData]);

  return (
  <>
      <h4 className="mb-4">Timing</h4>

<MembershipSummaryBanner formData={formData} />





      {/* Reveal the rest only after membershipType is selected */}
      {formData.membershipType && (
        <>


        <div className="row g-3">

          <div className="col-12">
            <h5 className="mt-4 mb-0">How long will the Membership last once started for the client?</h5>
          </div>

          <div className="col-md-4" style={{margin:'unset'}}>
            <label>Duration *</label>
            <input
              type="number"
              name="membershipPeriodQty"
              value={formData.membershipPeriodQty || ''}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-4" style={{margin:'unset'}}>
            <label>Period *</label>
            <select
              name="membershipPeriodUnit"
              className="form-select"
              value={formData.membershipPeriodUnit || ''}
              onChange={handleChange}
            >
              <option value="">Select Period</option>
              {MembershipPeriodUnitList.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

        </div>

        <div className="row g-3">


          <div className="col-12">
            <h5 className="mt-4 mb-0">How long will this membership be offered to clients (leave End Date blank if it will be offered perpetually)</h5>
          </div>

          <div className="col-md-4" style={{margin:'unset'}}>
            <label>Start Date *</label>
            <input
              type="date"
              name="membershipOfferBeginsOn"
              value={formData.membershipOfferBeginsOn ? Utilities.toDate(formData.membershipOfferBeginsOn) : null}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-4" style={{margin:'unset'}}>
            <label>End Date</label>
            <input
              type="date"
              name="membershipOfferEndsOn"
              disabled={formData.membershipOfferBeginsOn ? false : true}
              value={formData.membershipOfferEndsOn ? Utilities.toDate(formData.membershipOfferEndsOn) : ""}
              min={formData.membershipOfferBeginsOn}
              onChange={handleChange}
              className="form-control"
            />

          </div>

        </div>






          {/* Option Package specific fields */}

        </>
      )}
























  </>

  );
};

export default WizardStep1a;
